module.exports = __webpack_public_path__ + "static/img/VN.55cf34bd.png";